import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

interface RevenueReportingAmountRowProps {
  labelKey: string;
  value?: number;
  destructive?: boolean;
}

const RevenueReportingAmountRow: React.FC<RevenueReportingAmountRowProps> = (props) => {
  const amount = props.value ?? 0;

  return (
    <Grid container wrap="nowrap" className={cssExports.revenueReportingAmountRow}>
      <label className={cssExports.revenueReportingAmountLabel}>
        {`${LocalizationHelperInstance.getFormattedMessage(props.labelKey)}:`}
      </label>
      <label
        className={clsx(
          cssExports.revenueReportingAmountValue,
          props.destructive ? cssExports.revenueReportingAmountDestructive : ""
        )}
      >
        {LocalizationHelperInstance.getFormattedCurrency(amount, CurrencyEnums.CurrencyCode.SEK)}
      </label>
    </Grid>
  );
};

export default RevenueReportingAmountRow;
